<template>
  <div class="con3">
    <div class="con3_title">e签宝电子签名产品受司法认可</div>
    <div class="con3_conBox">
      <div v-show="window_h1" class="conBox_list">
        <div class="conBox_list_title">《中华人民共和国电子签名法》第十三、十四条：认可可靠电子签名的合法效力</div>
        <div class="conBox_list_con">
          <p style="font-weight: bold;">第十三条</p>
          <p class="font-w400">电子签名同时符合下列条件的，视为可靠的电子签名；</p>
          <p class="font-w400">（一）电子签名制作数据用于电子签名时，属于电子签名人专有；</p>
          <p class="font-w400">（二）签署时电子签名制作数据仅由电子签名人控制；</p>
          <p class="font-w400">（三）签署后对电子签名的任何改动能够被发现；</p>
          <p class="font-w400">
            （四）签署后对数据电文内容和形式的任何改动能够被发现，当事人也可以选择使用符合其约定的可靠条件的电子签名。
          </p>
          <p style="font-weight: bold;">第十四条</p>
          <p class="font-w400">可靠的电子签名与手写签名或者盖章具有同等的法律效力。</p>
        </div>
        <div class="ckbutton" @mouseover="showHover(1)">查看具体方案</div>
      </div>
      <div v-show="!window_h1" class="conBox_listhover" @mouseleave="leaveHover(1)">
        <div class="conBox_list_title">《中华人民共和国电子签名法》第十三、十四条：认可可靠电子签名的合法效力</div>
        <div class="conBox_list_con">
          <p class="font-w500">真实身份</p>
          <p class="font-w400">通过人脸识别、公安部人口库身份查验、银行预留信息、EID、银行U盾等方式完成实名认证</p>
          <p class="font-w500" style="margin-top: 10px;">真实意愿</p>
          <p class="font-w400">采用签署口令、短信验证码、U盾认证、指纹认证、刷脸等方式实现签署身份认证。</p>
          <p class="umt_19 font-w500" style="margin-top: 10px;">原文未改、签名未改</p>
          <p class="font-w400">综合应用RSA、SM2、SHA256、SM3等密码算法，符合PADES标准，达到原文和签名防篡改目的</p>
        </div>
      </div>
      <div v-show="window_h2" class="conBox_list uml_2">
        <div class="conBox_list_title">《中华人民共和国民法典》第四百六十九条：认可以数据电文作为合同书面形式的合法载体</div>
        <div class="conBox_list_con">
          <p style="font-weight: bold;">第四百六十九条</p>
          <p class="font-w400">当事人订立合同，可以采用书面形式、口头形式或者其他形式。</p>
          <p class="font-w400">
            书面形式是合同书、信件、电报、电传、传真等可以有形地表现所载内容的形式。
          </p>
          <p class="font-w400">
            以电子数据交换、电子邮件等方式能够有形地表现所载内容，并可以随时调取查用的数据电文，视为书面形式。
          </p>
        </div>
        <div class="ckbutton" @mouseover="showHover(2)">查看具体方案</div>
      </div>
      <div v-show="!window_h2" class="conBox_listhover uml_2" @mouseleave="leaveHover(2)">
        <div class="conBox_list_title">《中华人民共和国民法典》第四百六十九条：认可以数据电文作为合同书面形式的合法载体</div>
        <div class="conBox_list_con">
          <p class="font-w500">e签宝电子合同赋能企业，让企业具有轻松完成在线签署人事劳动合同和在线开具人事证明的能力。</p>
        </div>
      </div>
      <div v-show="window_h4" class="conBox_list uml_2 umt_18">
        <div class="conBox_list_title">《中华人民共和国民事诉讼法》第六十三条：认可电子数据作为法定证据种类的合法地位</div>
        <div class="conBox_list_con">
          <p style="font-weight: bold;">第六十三条</p>
          <p class="font-w400">
            证据包括：（一）当事人的陈述；（二）书证；（三）物证；（四）视听资料；（五）电子数据；（六）证人证言；（七）鉴定意见；（八）勘验笔录。
          </p>
          <p class="font-w400">
            2017年3月23日，全国首个电子劳动合同仲裁案件获得裁决，案件中由e签宝出具的电子证据报告，均被杭州市西湖区劳动人事争议仲裁委员会予以认可。
          </p>
        </div>
        <div class="ckbutton" @mouseover="showHover(4)">查看具体方案</div>
      </div>
      <div v-show="!window_h4" class="conBox_listhover uml_2 umt_18" @mouseleave="leaveHover(4)">
        <div class="conBox_list_title">《中华人民共和国民事诉讼法》第六十三条：认可电子数据作为法定证据种类的合法地位</div>
        <div class="conBox_list_con">
          <p class="font-w400">
            2017年3月23日，全国首个电子劳动合同仲裁案件获得裁决，案件中由e签宝出具的电子证据报告，均被杭州市西湖区劳动人事争议仲裁委员会予以认可。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      window_h1: true,
      window_h2: true,
      window_h3: true,
      window_h4: true,
    }
  },
  methods: {
    toggleHover(tr, val) {
      this[`window_h${tr}`] = val
    },
    showHover(tr) {
      this.toggleHover(tr, false)
    },
    leaveHover(tr) {
      this.toggleHover(tr, true)
    },
  },
}
</script>

<style lang="less" scoped>
.con3_title {
  display: flex;
  justify-content: center;
  font-size: 36px;
  color: #333;
  padding-top: 70px;
}

.con3 {
  width: 100%;
  height: 700px;
}

.con3_conBox {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin: 40px auto;
  flex-wrap: wrap;
  cursor: pointer;

  .conBox_list {
    width: 385px;
    height: 440px;
    border: 1px solid #e8e8e8;
    position: relative;

    &_title {
      height: 70px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      color: #333;
      font-weight: 400;
      background: #f1f1f1;
      padding: 14px;
    }

    .conBox_list_con {
      padding: 24px 22px 0;
      color: #333;

      p {
        margin: 0;
      }

      .umt_19 {
        margin-top: 19px;
      }

      .font-w400 {
        font-weight: 400px;
      }

      .font-w500 {
        font-weight: 500px;
      }
    }

    .ckbutton {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      color: #e61717;
      font-size: 14px;
      bottom: 0;
      position: absolute;
      cursor: pointer;
      right: 0;
      left: 0;
    }
  }

  .conBox_listhover {
    width: 385px;
    height: 440px;
    border: 1px solid #e61717;
    position: relative;
    background: #e61717;

    .conBox_list_title {
      height: 70px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      color: #e61717;
      font-weight: 400;
      background: #fff;
      padding: 14px;
    }

    .conBox_list_con {
      padding: 24px 22px 0;
      color: #fff;

      p {
        margin: 0;
      }

      p .umt_19 {
        margin-top: 10px;
      }

      .font-w400 {
        font-weight: 400px;
      }

      .font-w500 {
        font-weight: 700;
      }
    }
  }

  .uml_2 {
    margin-left: 20px;
  }
}
</style>
